import { Link } from '@remix-run/react'

export default function PrivacyRoute() {
	return (
		<div className="mx-auto max-w-4xl p-6 sm:p-12">
			<header className="mb-8">
				<h1 className="text-3xl text-center font-bold">
					Política de Privacidad
				</h1>
				<p className="text-sm mt-2 text-center text-gray-500">
					Última actualización: 17 de agosto de 2024
				</p>
			</header>
			<p className="mb-6">
				Esta Política de Privacidad describe nuestras políticas y procedimientos
				sobre la recopilación, uso y divulgación de su información cuando
				utiliza el Servicio y le informa sobre sus derechos de privacidad y cómo
				la ley lo protege.
			</p>
			<p className="mb-6">
				Utilizamos sus datos personales para proporcionar y mejorar el Servicio.
				Al utilizar el Servicio, usted acepta la recopilación y el uso de
				información de acuerdo con esta Política de Privacidad. Esta Política de
				Privacidad ha sido creada con la ayuda del{' '}
				<a
					href="https://www.termsfeed.com/privacy-policy-generator/"
					target="_blank"
					className="text-blue-500 hover:underline"
					rel="noreferrer"
				>
					Generador de Políticas de Privacidad
				</a>
				.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Interpretación y Definiciones
			</h2>
			<h3 className="text-xl mb-2 mt-4 font-bold">Interpretación</h3>
			<p className="mb-4">
				Las palabras cuyo primer carácter está en mayúscula tienen significados
				definidos en las siguientes condiciones. Las siguientes definiciones
				tendrán el mismo significado independientemente de si aparecen en
				singular o en plural.
			</p>

			<h3 className="text-xl mb-2 mt-4 font-bold">Definiciones</h3>
			<p className="mb-4">Para los fines de esta Política de Privacidad:</p>
			<ul className="inset-4 mb-6 list-disc">
				<li>
					<p>
						<strong>Cuenta</strong> significa una cuenta única creada para que
						usted acceda a nuestro Servicio o partes de nuestro Servicio.
					</p>
				</li>
				<li>
					<p>
						<strong>Afiliado</strong> significa una entidad que controla, es
						controlada por, o está bajo control común con una parte, donde
						"control" significa la propiedad del 50% o más de las acciones,
						participaciones u otros valores con derecho a voto para la elección
						de directores u otra autoridad de gestión.
					</p>
				</li>
				<li>
					<p>
						<strong>Compañía</strong> (referida como "la Compañía", "Nosotros",
						"Nos" o "Nuestro" en este Acuerdo) se refiere a Moni.
					</p>
				</li>
				<li>
					<p>
						<strong>Cookies</strong> son pequeños archivos que se colocan en su
						computadora, dispositivo móvil o cualquier otro dispositivo por un
						sitio web, que contienen los detalles de su historial de navegación
						en ese sitio web, entre sus muchos usos.
					</p>
				</li>
				<li>
					<p>
						<strong>País</strong> se refiere a: Perú
					</p>
				</li>
				<li>
					<p>
						<strong>Dispositivo</strong> significa cualquier dispositivo que
						pueda acceder al Servicio, como una computadora, un teléfono móvil o
						una tableta digital.
					</p>
				</li>
				<li>
					<p>
						<strong>Datos Personales</strong> es cualquier información que se
						relacione con una persona identificada o identificable.
					</p>
				</li>
				<li>
					<p>
						<strong>Servicio</strong> se refiere al sitio web.
					</p>
				</li>
				<li>
					<p>
						<strong>Proveedor de Servicios</strong> significa cualquier persona
						natural o jurídica que procese los datos en nombre de la Compañía.
						Se refiere a terceras empresas o personas contratadas por la
						Compañía para facilitar el Servicio, para prestar el Servicio en
						nombre de la Compañía, para realizar servicios relacionados con el
						Servicio o para ayudar a la Compañía a analizar cómo se utiliza el
						Servicio.
					</p>
				</li>
				<li>
					<p>
						<strong>Datos de Uso</strong> se refiere a los datos recopilados
						automáticamente, ya sea generados por el uso del Servicio o de la
						infraestructura del Servicio en sí (por ejemplo, la duración de una
						visita a una página).
					</p>
				</li>
				<li>
					<p>
						<strong>Sitio Web</strong> se refiere a Moni, accesible desde{' '}
						<a
							href="https://somosmoni.com"
							rel="external nofollow noopener noreferrer"
							target="_blank"
							className="text-blue-500 hover:underline"
						>
							https://somosmoni.com
						</a>
					</p>
				</li>
				<li>
					<p>
						<strong>Usted</strong> se refiere a la persona que accede o utiliza
						el Servicio, o la empresa u otra entidad legal en nombre de la cual
						dicha persona accede o utiliza el Servicio, según corresponda.
					</p>
				</li>
			</ul>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Recopilación y Uso de sus Datos Personales
			</h2>

			<h3 className="text-xl mb-2 mt-4 font-bold">
				Tipos de Datos Recopilados
			</h3>
			<h4 className="text-lg mb-2 mt-4 font-bold">Datos Personales</h4>
			<p className="mb-4">
				Mientras usa Nuestro Servicio, podemos pedirle que nos proporcione
				cierta información de identificación personal que puede utilizarse para
				contactarlo o identificarlo. La información de identificación personal
				puede incluir, pero no se limita a:
			</p>
			<ul className="mb-6  list-disc">
				<li>Dirección de correo electrónico</li>
				<li>Nombre y apellido</li>
				<li>Número de teléfono</li>
				<li>Dirección, Estado, Provincia, Código Postal, Ciudad</li>
				<li>Datos de Uso</li>
			</ul>

			<h4 className="text-lg mb-2 mt-4 font-bold">Datos de Uso</h4>
			<p className="mb-4">
				Los Datos de Uso se recopilan automáticamente cuando se utiliza el
				Servicio.
			</p>
			<p className="mb-4">
				Los Datos de Uso pueden incluir información como la dirección de
				Protocolo de Internet (por ejemplo, dirección IP) de su Dispositivo,
				tipo de navegador, versión del navegador, las páginas de nuestro
				Servicio que visita, la hora y fecha de su visita, el tiempo que pasa en
				esas páginas, identificadores únicos de dispositivos y otros datos de
				diagnóstico.
			</p>
			<p className="mb-4">
				Cuando accede al Servicio a través de un dispositivo móvil, podemos
				recopilar cierta información automáticamente, incluidos, entre otros, el
				tipo de dispositivo móvil que utiliza, su ID único de dispositivo móvil,
				la dirección IP de su dispositivo móvil, su sistema operativo móvil, el
				tipo de navegador de Internet móvil que utiliza, identificadores únicos
				de dispositivo y otros datos de diagnóstico.
			</p>
			<p className="mb-4">
				También podemos recopilar información que su navegador envía cada vez
				que visita nuestro Servicio o cuando accede al Servicio a través de un
				dispositivo móvil.
			</p>

			<h4 className="text-lg mb-2 mt-4 font-bold">
				Tecnologías de Seguimiento y Cookies
			</h4>
			<p className="mb-4">
				Utilizamos Cookies y tecnologías de seguimiento similares para rastrear
				la actividad en nuestro Servicio y almacenar cierta información. Las
				tecnologías de seguimiento utilizadas son balizas, etiquetas y scripts
				para recopilar y rastrear información y para mejorar y analizar nuestro
				Servicio. Las tecnologías que utilizamos pueden incluir:
			</p>
			<ul className="mb-6  list-disc">
				<li>
					<strong>Cookies o Cookies del Navegador.</strong> Una cookie es un
					pequeño archivo colocado en su Dispositivo. Puede indicar a su
					navegador que rechace todas las Cookies o que le indique cuándo se
					está enviando una Cookie. Sin embargo, si no acepta Cookies, es
					posible que no pueda utilizar algunas partes de nuestro Servicio. A
					menos que haya configurado su navegador para que rechace Cookies,
					nuestro Servicio puede usar Cookies.
				</li>
				<li>
					<strong>Balizas Web.</strong> Ciertas secciones de nuestro Servicio y
					nuestros correos electrónicos pueden contener pequeños archivos
					electrónicos conocidos como balizas web (también denominados gifs
					claros, etiquetas de píxeles y gifs de un solo píxel) que permiten a
					la Compañía, por ejemplo, contar usuarios que han visitado esas
					páginas o abierto un correo electrónico y para otras estadísticas
					relacionadas con el sitio web (por ejemplo, registrar la popularidad
					de una determinada sección y verificar la integridad del sistema y del
					servidor).
				</li>
			</ul>
			<p className="mb-4">
				Las Cookies pueden ser "Persistentes" o "De Sesión". Las Cookies
				Persistentes permanecen en su computadora personal o dispositivo móvil
				cuando se desconecta, mientras que las Cookies de Sesión se eliminan tan
				pronto como cierra su navegador web. Puede obtener más información sobre
				cookies y cómo gestionarlas en{' '}
				<a
					href="https://www.allaboutcookies.org/"
					target="_blank"
					className="text-blue-500 hover:underline"
					rel="noreferrer"
				>
					www.allaboutcookies.org
				</a>
				.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Uso de sus Datos Personales
			</h2>
			<p className="mb-4">
				La Compañía utiliza los Datos Personales para los siguientes propósitos:
			</p>
			<ul className="mb-6  list-disc">
				<li>
					<strong>Para proporcionar y mantener nuestro Servicio</strong>:
					Incluye monitoreo del uso de nuestro Servicio.
				</li>
				<li>
					<strong>Para notificarle sobre cambios en nuestro Servicio</strong>.
				</li>
				<li>
					<strong>
						Para permitirle participar en funciones interactivas de nuestro
						Servicio cuando elija hacerlo
					</strong>
					.
				</li>
				<li>
					<strong>Para brindar atención al cliente</strong>.
				</li>
				<li>
					<strong>
						Para recopilar análisis o información valiosa para que podamos
						mejorar nuestro Servicio
					</strong>
					.
				</li>
				<li>
					<strong>Para controlar el uso de nuestro Servicio</strong>.
				</li>
				<li>
					<strong>Para detectar, prevenir y abordar problemas técnicos</strong>.
				</li>
				<li>
					<strong>
						Para enviarle noticias, ofertas especiales e información general
						sobre otros bienes, servicios y eventos que ofrecemos que son
						similares a los que ya ha adquirido o preguntado, a menos que haya
						optado por no recibir dicha información.
					</strong>
				</li>
			</ul>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Conservación de sus Datos Personales
			</h2>
			<p className="mb-4">
				La Compañía conservará sus Datos Personales solo durante el tiempo
				necesario para los fines establecidos en esta Política de Privacidad.
				Conservaremos y usaremos sus Datos Personales en la medida necesaria
				para cumplir con nuestras obligaciones legales (por ejemplo, si debemos
				conservar sus datos para cumplir con las leyes aplicables), resolver
				disputas y hacer cumplir nuestros acuerdos y políticas legales.
			</p>
			<p className="mb-4">
				La Compañía también conservará los Datos de Uso con fines de análisis
				interno. Los Datos de Uso generalmente se conservan durante un período
				más corto, excepto cuando estos datos se utilizan para fortalecer la
				seguridad o mejorar la funcionalidad de nuestro Servicio, o cuando
				estamos legalmente obligados a conservar estos datos durante períodos de
				tiempo más largos.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Transferencia de sus Datos Personales
			</h2>
			<p className="mb-4">
				Su información, incluidos los Datos Personales, puede ser transferida a
				- y mantenida en - computadoras ubicadas fuera de su estado, provincia,
				país o cualquier otra jurisdicción gubernamental donde las leyes de
				protección de datos puedan diferir de las de su jurisdicción.
			</p>
			<p className="mb-4">
				Si se encuentra fuera de Perú y decide proporcionarnos información,
				tenga en cuenta que transferimos los datos, incluidos los Datos
				Personales, a Perú y los procesamos allí.
			</p>
			<p className="mb-4">
				Su consentimiento a esta Política de Privacidad seguido por su envío de
				dicha información representa su acuerdo con esa transferencia.
			</p>
			<p className="mb-4">
				La Compañía tomará todas las medidas razonablemente necesarias para
				garantizar que sus datos sean tratados de manera segura y de acuerdo con
				esta Política de Privacidad y no se realice ninguna transferencia de sus
				Datos Personales a una organización o a un país a menos que haya
				controles adecuados en su lugar que incluyan la seguridad de sus datos y
				otra información personal.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Divulgación de sus Datos Personales
			</h2>
			<h3 className="text-xl mb-2 mt-4 font-bold">Transacciones Comerciales</h3>
			<p className="mb-4">
				Si la Compañía participa en una fusión, adquisición o venta de activos,
				sus Datos Personales pueden ser transferidos. Le notificaremos antes de
				que sus Datos Personales sean transferidos y estén sujetos a una
				Política de Privacidad diferente.
			</p>

			<h3 className="text-xl mb-2 mt-4 font-bold">Cumplimiento de la Ley</h3>
			<p className="mb-4">
				La Compañía puede divulgar sus Datos Personales en la creencia de buena
				fe de que dicha acción es necesaria para:
			</p>
			<ul className="mb-6  list-disc">
				<li>Cumplir con una obligación legal</li>
				<li>Proteger y defender los derechos o propiedad de la Compañía</li>
				<li>
					Prevenir o investigar posibles irregularidades en relación con el
					Servicio
				</li>
				<li>
					Proteger la seguridad personal de los usuarios del Servicio o del
					público
				</li>
				<li>Protegerse contra la responsabilidad legal</li>
			</ul>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Seguridad de sus Datos Personales
			</h2>
			<p className="mb-4">
				La seguridad de sus Datos Personales es importante para nosotros, pero
				recuerde que ningún método de transmisión por Internet o método de
				almacenamiento electrónico es 100% seguro. Aunque nos esforzamos por
				utilizar medios comercialmente aceptables para proteger sus Datos
				Personales, no podemos garantizar su seguridad absoluta.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Sus Derechos de Protección de Datos
			</h2>
			<p className="mb-4">
				Dependiendo de su ubicación, puede tener derechos adicionales sobre sus
				Datos Personales. En ciertos casos, puede tener los siguientes derechos:
			</p>
			<ul className="mb-6  list-disc">
				<li>
					<strong>Derecho a acceder:</strong> Puede tener el derecho a solicitar
					una copia de los Datos Personales que tenemos sobre usted.
				</li>
				<li>
					<strong>Derecho a rectificación:</strong> Puede tener el derecho a
					solicitar que corrijamos cualquier dato personal incorrecto o
					incompleto.
				</li>
				<li>
					<strong>Derecho a borrar:</strong> En ciertas circunstancias, puede
					tener el derecho a solicitar que borremos sus Datos Personales.
				</li>
				<li>
					<strong>Derecho a restringir el procesamiento:</strong> Puede tener el
					derecho a solicitar la restricción del procesamiento de sus Datos
					Personales en ciertas circunstancias.
				</li>
				<li>
					<strong>Derecho a objetar el procesamiento:</strong> Puede tener el
					derecho a objetar el procesamiento de sus Datos Personales en ciertas
					circunstancias.
				</li>
				<li>
					<strong>Derecho a la portabilidad de datos:</strong> Puede tener el
					derecho a recibir los Datos Personales que ha proporcionado a la
					Compañía en un formato estructurado, de uso común y lectura mecánica.
				</li>
			</ul>
			<p className="mb-4">
				Para ejercer estos derechos, contáctenos a través de la información de
				contacto proporcionada a continuación.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Enlaces a Otros Sitios Web
			</h2>
			<p className="mb-4">
				Nuestro Servicio puede contener enlaces a otros sitios web que no son
				operados por nosotros. Si hace clic en un enlace de un tercero, será
				dirigido al sitio web de ese tercero. Le recomendamos encarecidamente
				que revise la Política de Privacidad de cada sitio web que visite.
			</p>
			<p className="mb-4">
				No tenemos control sobre y no asumimos ninguna responsabilidad por el
				contenido, las políticas de privacidad o las prácticas de los sitios web
				o servicios de terceros.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">Privacidad de los Niños</h2>
			<p className="mb-4">
				Nuestro Servicio no está dirigido a menores de 13 años. No recopilamos
				deliberadamente información personal identificable de menores de 13
				años. Si es un padre o tutor y tiene conocimiento de que su hijo nos ha
				proporcionado Datos Personales, contáctenos. Si nos damos cuenta de que
				hemos recopilado Datos Personales de menores de 13 años sin verificación
				del consentimiento de los padres, tomamos medidas para eliminar esa
				información de nuestros servidores.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">
				Cambios en esta Política de Privacidad
			</h2>
			<p className="mb-4">
				Podemos actualizar nuestra Política de Privacidad de vez en cuando. Le
				notificaremos de cualquier cambio publicando la nueva Política de
				Privacidad en esta página.
			</p>
			<p className="mb-4">
				Le informaremos por correo electrónico y/o mediante un aviso prominente
				en nuestro Servicio, antes de que el cambio entre en vigencia y
				actualizaremos la "última fecha de actualización" en la parte superior
				de esta Política de Privacidad.
			</p>
			<p className="mb-4">
				Se le aconseja revisar esta Política de Privacidad periódicamente para
				cualquier cambio. Los cambios en esta Política de Privacidad son
				efectivos cuando se publican en esta página.
			</p>

			<h2 className="text-2xl mb-4 mt-6 font-bold">Contáctenos</h2>
			<p className="mb-4">
				Si tiene alguna pregunta sobre esta Política de Privacidad, por favor
				contáctenos:
			</p>
			<ul className="mb-6  list-disc">
				<li>
					<strong>Por correo electrónico:</strong>{' '}
					<Link
						to="mailto:soporte@somosmoni.com"
						className="text-primary hover:underline"
						target="_blank"
						rel="noreferrer"
					>
						soporte@somosmoni.com
					</Link>
				</li>
				<li>
					<strong>Por teléfono:</strong> +51 903 568 143
				</li>
			</ul>
		</div>
	)
}
